import React, { ReactNode, ComponentType } from 'react';
import { Button } from '@framework-controls/core';
import { ReactComponent as IconRightArrow } from 'src/content/icons/RightArrow.svg';
import * as css from './LandingButton.module.scss';
import classNames from 'classnames';

interface IProps {
    header: string;
    message: ReactNode;
    iconName: ComponentType;
    handler: (event: any) => void;
    title: string;
    id: string;
    lastFlag: boolean;
    theme: string;
}

const LandingButton = (props: IProps) => {
    let btnClassName = css.button;
    if (props.lastFlag) {
        btnClassName = css.lastBtn;
    }
    if (props.theme === 'ford' && props.lastFlag) {
        btnClassName = css.fordLastBtn;
    }

    const btnHeadingTextStyles = classNames(
        css.btnHeadingText,
        {
            [css.btnHeadingText400]: props.theme === 'honda',
            [css.btnHeadingText600]: props.theme === 'buick',
            [css.btnHeadingText700]: props.theme === 'infiniti',
            [css.btnHeadingTextBaseWeight]: props.theme === 'bmw',
            [css.btnHeadingTextHeadingWeight]: props.theme === 'ford',
            [css.btnHeadingMazda]: props.theme === 'mazda',
            [css.btnHeadingAcura]: props.theme === 'acura',
        },
    );

    const smallStyles = classNames(
        css.small,
        {
            [css.smallBuick]: props.theme === 'buick',
        },
    );

    return (
        <div className={btnClassName}>
            <Button
                id={props.id + 'btn'}
                variant={props.theme === 'honda' ? 'landingButtonHonda' : 'landingButton'}
                type={'custom'}
                tooltip={props.title}
                onClick={props.handler}>
                <div className={css.iconBorder}>
                    <span className={css.icon}>
                        <props.iconName />
                    </span>
                </div>
                <div className={css.btnTextContent}>
                    <div className={btnHeadingTextStyles}>{props.header}</div>
                    <small className={smallStyles}>
                        {props.message}
                    </small>
                </div>
                <div className={css.arrowIcon}>
                    <IconRightArrow className={css.arrowIcon2} />
                </div>
            </Button>
        </div>
    );
};

export default LandingButton;
